import { useDock } from "@circle-react-uikit/CircleAIAppShell/hooks/useDock";
import { useCircleAIShellStore } from "@circle-react-uikit/CircleAIAppShell/store/circleAIShellStore";
import { useEffect } from "react";

import { useIsReplitOnboardingModalEligible } from "@/react/components/CircleAi/ReplitOnboardingModal/useIsReplitOnboardingModalEligible";

interface UseDesktopDockStateProps {
  isAdminArea: boolean;
  isAdminDockNavVisible: boolean;
  isDockEligible: boolean;
  shouldCollapseForPromoLockedCommunitySwitcher: boolean;
}

export const useDesktopDockState = ({
  isAdminArea,
  isAdminDockNavVisible,
  isDockEligible,
  shouldCollapseForPromoLockedCommunitySwitcher,
}: UseDesktopDockStateProps) => {
  const isDockManualOverride = useCircleAIShellStore(
    s => s.isDockManualOverride,
  );
  const setDockMode = useCircleAIShellStore(s => s.setDockMode);
  const isReplitOnboardingPending = useIsReplitOnboardingModalEligible();
  const shouldCollapseDockWithoutControls =
    isDockEligible && !isAdminArea && !isAdminDockNavVisible;

  // Normal navigation preserves the user's dock preference. Restricted
  // layouts stay compact when they do not render a dock toggle control.
  useDock({
    enabled:
      shouldCollapseForPromoLockedCommunitySwitcher ||
      shouldCollapseDockWithoutControls,
    mode: "collapsed",
  });

  // Onboarding may open the dock once, but must not overwrite an explicit
  // user toggle later in the same session.
  useEffect(() => {
    if (isReplitOnboardingPending && !isDockManualOverride) {
      setDockMode("expanded");
    }
  }, [isReplitOnboardingPending, isDockManualOverride, setDockMode]);
};
